import React from 'react';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { connect } from 'react-redux'

class ModalBlockWrapper extends React.Component {
  render() {
    return (
      <BlockUi tag="main" blocking={this.props.loading} message="Cargando...">
        {this.props.content}
      </BlockUi>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
      loading: state.get('loading'),
    };
}

export default connect(mapStateToProps)(ModalBlockWrapper);



// WEBPACK FOOTER //
// ./src/views/Components/ModalBlockWrapper.jsx